
/**
 * React component for the description section on the Learn Home page.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data containing information for the Learn Home description.
 * @returns {JSX.Element} React component.
 */

import React from "react";
import Number from "../Number";
import LearnHomeImageSection from "./LearnHomeImageSection";

export default function LearnHomeDescription({ data }) {
  return (
    <section className="w-full h-full mt-[40px] lg:mt-[200px] px-[24px] lg:px-0">
      <Number numberBgColors={"#9EACFD"} numberText={"02"} />
      <div className="mt-[24px] lg:mt-[32px] relative max-w-[1009px] m-auto">
        <div className={`text-center pb-[16px] lg:pb-[24px] mx-[24px] lg:mx-0`}>
          <h2>Maps nonstop. Detects nonstop. Avoids nonstop.</h2>
        </div>
        <div className={`text-center mx-[16px]`}>
          <p className=" max-w-[617px] m-auto">
            Matic deftly navigates around wires and obstacles larger than 1".
          </p>
          <p className=" max-w-[617px] m-auto">
            Watch Matic because you want to, not because you have to.
          </p>
        </div>
      </div>

      <LearnHomeImageSection data={data} />
    </section>
  );
}
